import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (projectExpense) =>
    present(
      repository
        .removeProjectExpense(projectExpense)
        .then(() => projectExpense)
        .catch(() => Promise.reject(projectExpense)),
    );
}

export type { Interactor };

export { createInteractor };
